'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.getAll = getAll;
exports.clear = clear;

var _styleSheet = require('./utils/style-sheet');

var _styleSheet2 = _interopRequireDefault(_styleSheet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var styleSheet = new _styleSheet2.default();
styleSheet.inject();

function add(styles) {
  styleSheet.insert(styles);
}

function getAll() {
  // Convert rules array to a string
  return styleSheet.rules().reduce(function (combinedRules, rule) {
    return combinedRules + rule.cssText;
  }, '');
}

function clear() {
  styleSheet.flush();
  styleSheet.inject();
}